<span class="snackBarProperty">
    {{data}}
</span>
